<script lang="ts" setup>
import type { User } from "@twiage/core/types/User";
import type { DeepReadonly } from "ts-essentials";
// TODO
// Components inside this View package should not handle routing.
// They should emit an event and let the Nuxt layer deal with it or
// Receive computed props with the values they require.
// As it was done for edit user.
// eslint-disable-next-line no-restricted-imports
import { useRoute } from "vue-router";

import { useAuthenticationStore } from "../stores/use-authentication-store";
import { useGeneralStore } from "../stores/use-general-store";

const props = defineProps<{
  user?: DeepReadonly<User>;
}>();

const authenticationStore = useAuthenticationStore();
const generalStore = useGeneralStore();

const route = useRoute();
</script>

<template>
  <nav
    class="navbar navbar-expand-sm simple-navbar sticky-top"
    data-bs-theme="dark"
  >
    <div class="container-fluid">
      <RouterLink class="navbar-brand" to="/">Twiage</RouterLink>

      <button
        aria-controls="simpleNavbar"
        aria-expanded="false"
        aria-label="Toggle navigation"
        class="navbar-toggler"
        data-bs-target="#simpleNavbar"
        data-bs-toggle="collapse"
        type="button"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div id="simpleNavbar" class="collapse navbar-collapse">
        <ul class="mb-2 mb-sm-0 me-auto navbar-nav">
          <li class="nav-item">
            <RouterLink
              class="nav-link"
              :class="{ active: route.path === '/users' }"
              to="/users"
            >
              Users
            </RouterLink>
          </li>
        </ul>

        <ul v-if="props.user" class="mb-2 mb-sm-0 navbar-nav">
          <li class="nav-item dropdown">
            <a
              aria-expanded="false"
              class="dropdown-toggle nav-link"
              data-bs-toggle="dropdown"
              href="#"
              role="button"
            >
              {{ props.user?.displayName }}
            </a>

            <ul class="dropdown-menu dropdown-menu-end">
              <li><a class="disabled dropdown-item" href="#">Profile</a></li>

              <li>
                <hr class="dropdown-divider" />
              </li>

              <li><h6 class="dropdown-header">Options</h6></li>

              <li>
                <a
                  class="dropdown-item"
                  href="#"
                  :title="`Click to turn ${generalStore.toggleableGlobalOptions.useModals === true ? 'off' : 'on'}`"
                  @click="generalStore.toggleUseModals()"
                >
                  <i
                    v-if="
                      generalStore.toggleableGlobalOptions.useModals === true
                    "
                    class="bi bi-check-lg"
                    style="color: lightgreen"
                  ></i>
                  <i
                    v-if="
                      generalStore.toggleableGlobalOptions.useModals === false
                    "
                    class="bi bi-x-lg"
                    style="color: lightcoral"
                  ></i>
                  Use Router
                </a>
              </li>

              <li>
                <a
                  class="dropdown-item"
                  href="#"
                  :title="`Click to turn ${generalStore.toggleableGlobalOptions.useFluidLayout === true ? 'off' : 'on'}`"
                  @click="generalStore.toggleUseFluidLayout()"
                >
                  <i
                    v-if="
                      generalStore.toggleableGlobalOptions.useFluidLayout ===
                      true
                    "
                    class="bi bi-check-lg"
                    style="color: lightgreen"
                  ></i>
                  <i
                    v-if="
                      generalStore.toggleableGlobalOptions.useFluidLayout ===
                      false
                    "
                    class="bi bi-x-lg"
                    style="color: lightcoral"
                  ></i>
                  Fluid Layout
                </a>
              </li>

              <li>
                <a
                  class="dropdown-item"
                  href="#"
                  :title="`Click to turn ${generalStore.toggleableGlobalOptions.useScrollFieldsOnly === true ? 'off' : 'on'}`"
                  @click="generalStore.toggleUseScrollFieldsOnly()"
                >
                  <i
                    v-if="
                      generalStore.toggleableGlobalOptions
                        .useScrollFieldsOnly === true
                    "
                    class="bi bi-check-lg"
                    style="color: lightgreen"
                  ></i>
                  <i
                    v-if="
                      generalStore.toggleableGlobalOptions
                        .useScrollFieldsOnly === false
                    "
                    class="bi bi-x-lg"
                    style="color: lightcoral"
                  ></i>
                  Scroll Fields Only
                </a>
              </li>

              <li class="dropdown-divider"></li>

              <li>
                <a
                  class="dropdown-item"
                  href="#"
                  @click="authenticationStore.logout"
                >
                  Logout
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<style scoped>
.simple-navbar {
  background-color: #981b1e;
  /* --bs-navbar-padding-y: 3rem;
  --bs-navbar-color:
  --bs-navbar-hover-color:
  --bs-navbar-disabled-color:
  --bs-navbar-active-color:
  --bs-navbar-brand-font-size:
  --bs-navbar-brand-color:
  --bs-navbar-brand-hover-color: */
}
</style>
